import React, { FunctionComponent, ComponentProps, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SynchronizationStatusContext } from '../../context/SynchronizationStatusContext';
import { prepareProps } from '../../utils/propUtils';
import { ItemsToSynchronizeListItem } from '../ItemsToSynchronizeListItem/ItemsToSynchronizeListItem';
import styles from './ItemsToSynchronizeList.module.css';

export type ItemsToSynchronizeListProps = ComponentProps<'div'>;

export const ItemsToSynchronizeList: FunctionComponent<ItemsToSynchronizeListProps> =
  React.memo((props) => {
    const { ...remainingProps } = prepareProps({ props, ignoreChildren: true });
    const { t } = useTranslation('record-it-components');
    const synchronizationStatus = useContext(SynchronizationStatusContext);

    return (
      <div {...remainingProps}>
        {synchronizationStatus.itemsToSynchronizeInfos.length !==
        0 ? undefined : (
          <div
            className={styles.allItemsSynchronized}
            data-testid="ItemsToSynchronizeList.allItemsSynchronized"
          >
            {t('synchronization.ItemsToSynchronizeList.allItemsSynchronized')}
          </div>
        )}

        {synchronizationStatus.itemsToSynchronizeInfos.length ===
        0 ? undefined : (
          <div className={styles.waitingForSynchronization}>
            {t(
              'synchronization.ItemsToSynchronizeList.waitingForSynchronization',
              { count: synchronizationStatus.itemsToSynchronizeInfos.length }
            )}
          </div>
        )}

        {synchronizationStatus.itemsToSynchronizeInfos.map((info) => (
          <ItemsToSynchronizeListItem
            itemToSynchronizeInfo={info}
            key={info.id}
            data-testid="ItemsToSynchronizeList.listItem"
          ></ItemsToSynchronizeListItem>
        ))}
      </div>
    );
  });
